import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueAWN from 'vue-awesome-notifications'
import BootstrapVue from 'bootstrap-vue'
import Loading from 'vue-loading-overlay'
import 'animate.css/animate.css'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'

// Filtros
import VueCurrencyFilter from 'vue-currency-filter'

import App from './App.vue'
import router from './router'
import store from './store/index'
import './scss/index.scss'

import LayoutBasico from './components/layouts/LayoutBasico.vue'
import LayoutBarraLateral from './components/layouts/LayoutBarraLateral.vue'
import LayoutTelas from './components/layouts/LayoutTelas.vue'

// Configurações de componentes
import notifications from './configs/notifications'
import veevalidate from './configs/veevalidate'
import iconesCustom from './configs/icones'

// Filtros customizados
import { formatDateTime, formatDate, formatTime } from './filters/data.filter'

// Módulos
// Quando tiver store interna, deve importar com o nomeModuloStore
// Caso contário só import 'caminho do modulo'
import { autenticacaoStore } from './modules/index'

// Registrar store de módulos filhos
store.registerModule('autenticacao', autenticacaoStore)

// Configuração de icones personalizados
Icon.register(iconesCustom)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VeeValidate, veevalidate)
Vue.use(VueAWN, notifications)
Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
})

// Filtros
Vue.filter('formatDateTime', formatDateTime)
Vue.filter('formatDate', formatDate)
Vue.filter('formatTime', formatTime)

// Registro de componentes fundamentais
Vue.component('LayoutBasico', LayoutBasico)
Vue.component('LayoutBarraLateral', LayoutBarraLateral)
Vue.component('LayoutTelas', LayoutTelas)
Vue.component('loading', Loading)
Vue.component('v-icon', Icon)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
